export const calculationTypes = [
  { label: 'Horizontal', value: 'HORIZONTAL' },
  { label: 'Slope', value: 'SLOPE' },
  { label: 'Quay', value: 'QUAY' }
]

export const calculationMethods = [
  { label: 'Dutch', value: 'DUTCH' },
  { label: 'German', value: 'GERMAN' }
]

export const favoriteOptions = [
  { label: 'All cross sections', value: null },
  { label: 'Only favorite items', value: true }
]
